function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "color",
  points: "164.72135954999578,134.64101615137756 100.0,176.05034153776296 35.278640450004204,134.64101615137756 35.278640450004204,65.35898384862244 100.0,23.949658462237053 164.72135954999578,65.35898384862244",
  stroke: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0,
  points: "140.0,132.3606797749979 60.0,132.3606797749979 100.0,63.94965846223705",
  stroke: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "35.278640450004204,65.35898384862244 60.0,132.3606797749979 100.0,63.94965846223705",
  stroke: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "164.72135954999578,65.35898384862244 140.0,132.3606797749979 100.0,63.94965846223705",
  stroke: "black"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.2,
  points: "140.0,132.3606797749979 60.0,132.3606797749979 100.0,176.05034153776296",
  stroke: "black"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "35.278640450004204,65.35898384862244 100.0,23.949658462237053 100.0,63.94965846223705",
  stroke: "black"
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "164.72135954999578,65.35898384862244 100.0,23.949658462237053 100.0,63.94965846223705",
  stroke: "black"
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "164.72135954999578,134.64101615137756 164.72135954999578,65.35898384862244 140.0,132.3606797749979",
  stroke: "black"
});

var _ref11 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "164.72135954999578,134.64101615137756 140.0,132.3606797749979 100.0,176.05034153776296",
  stroke: "black"
});

var _ref12 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "35.278640450004204,134.64101615137756 60.0,132.3606797749979 100.0,176.05034153776296",
  stroke: "black"
});

var _ref13 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "35.278640450004204,65.35898384862244 35.278640450004204,134.64101615137756 60.0,132.3606797749979",
  stroke: "black"
});

var SvgD20 = function SvgD20(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    baseProfile: "full",
    height: "200px",
    viewBox: "0 0 200 200",
    width: "200px",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgD20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d20.2a6ecaaa.svg";
export { ForwardRef as ReactComponent };